export default [
  {
    path: '/comments',
    name: 'comments',
    component: () => import('@/views/comments/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_comments',
      resource: 'all',
    },
  },
]
